/**
 * Action Name: md_clear_car_data
 */

export function clearCarDbTables() {
	var data = {
		action: 'md_clear_car_data',
		security: md_object.nonce
	};

	jQuery.ajax({
		data: data,
		success: function (response) {
			jQuery('#response').html(response);
		},
		error: function (err) {
			console.log(err);
		}
	});
}

/**
 * Action Name: md_clear_img_data
 */

export function clearImgDbTable() {
	var data = {
		action: 'md_clear_img_data',
		security: md_object.nonce
	};

	jQuery.ajax({
		data: data,
		success: function (response) {
			jQuery('#response').html(response);
		},
		error: function (err) {
			console.log(err);
		}
	});
}

export default { clearCarDbTables, clearImgDbTable };
